import { render, staticRenderFns } from "./HandleItemCategoryTabGeneral.vue?vue&type=template&id=13546196"
import script from "./HandleItemCategoryTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleItemCategoryTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleItemCategoryTabGeneral.vue?vue&type=style&index=0&id=13546196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports